<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        แก้ไขบทความ
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i> จัดการบทความ
          </a>
        </li>
        <li class="active">จัดการบทความ</li>
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box">
              <div class="box-header">
                <!-- <h3 class="box-title">Hover Data Table</h3> -->
                <div class="wrapper_addtypegroup">
                  <el-form
                    size="mini"
                    :label-position="label_position"
                    label-width="150px"
                    ref="ruleForm"
                    class="demo-ruleForm"
                  >
                    <div class="row">
                      <div class="col-xs-6">
                        <el-form size="mini">
                          <el-form-item label="หัวข้อบทความ (Thai)" required>
                            <el-input type="textarea" :rows="5" show-word-limit :maxlength="250" placeholder="กรุณากรอกข้อมูล" v-model="form.title_th"></el-input>
                          </el-form-item>
                          <el-form-item label="หัวข้อบทความ (Eng)" required>
                            <el-input type="textarea" :rows="5" show-word-limit :maxlength="250" placeholder="กรุณากรอกข้อมูล" v-model="form.title_en"></el-input>
                          </el-form-item>
                          <el-form-item label="รายละเอียดเบื้องต้น (Thai)" required>
                            <el-input
                              type="textarea"
                              :rows="10"
                              placeholder="กรุณากรอกข้อมูล"
                              v-model="form.short_description_th"
                              show-word-limit
                              :maxlength="250"
                            ></el-input>
                          </el-form-item>
                          <el-form-item label="รายละเอียดเบื้องต้น (Eng)" required>
                            <el-input
                              type="textarea"
                              :rows="10"
                              placeholder="กรุณากรอกข้อมูล"
                              v-model="form.short_description_en"
                              show-word-limit
                              :maxlength="250"
                            ></el-input>
                          </el-form-item>
                          <el-form-item label="รายละเอียด (Thai)" required>
                            <!-- <el-input placeholder="กรุณากรอกข้อมูล" v-model="form.descriptionTH"></el-input> -->
                            <VueEditor
                              :editor="editor"
                              v-model="form.full_description_th"
                              :config="editorConfig"
                            ></VueEditor>
                          </el-form-item>
                          <el-form-item label="รายละเอียด (Eng)" required>
                            <!-- <el-input placeholder="กรุณากรอกข้อมูล" v-model="form.descriptionEN"></el-input> -->
                            <VueEditor
                              :editor="editor"
                              v-model="form.full_description_en"
                              :config="editorConfig"
                            ></VueEditor>
                          </el-form-item>
                          <el-form-item label="รูปภาพ" required>
                            <!-- <div id="preview">
                              <img v-if="pic" :src="pic" />
                            </div>
                            <input type="file" ref="file" @change="onFileChange" /> -->
                            <div id="preview" style="height: 348px">
                              <template v-if="picshow">
                                <img v-if="form.thumbnail_image" :src="this.config().API_URL + form.thumbnail_image" />
                              </template>
                              <template else>
                              <img v-if="pic" :src="pic" />
                              </template>
                            </div>
                            <br />
                            <el-upload
                              type="file"
                              class="upload-demo"
                              ref="file"
                              action="#"
                              :on-change="onFileChange"
                              :show-file-list="false"
                              :limit="1"
                              :auto-upload="false"
                              accept="image/jpeg,image/png"
                            >
                            <el-button
                              slot="trigger"
                              size="small"
                              type="primary"
                            >เลือกรูปภาพ</el-button>
                            </el-upload>
                          </el-form-item>
                          <el-form-item label="การแสดงผล">
                            <el-radio-group v-model="form.status" size="small">
                              <el-radio :label="1">แสดง</el-radio>
                              <el-radio :label="0">ไม่แสดง</el-radio>
                            </el-radio-group>
                          </el-form-item>
                        </el-form>
                      </div>
                    </div>
                    <div class="box-footer">
                      <el-button style="float: left;" @click.prevent="back()">ยกเลิก</el-button> <el-button type="primary" style="float: right;" @click="submitForm()">บันทึก</el-button>
                    </div>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
    <!-- /.content -->
  </div>
</template>
<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { mapState, mapActions } from "vuex";
import { VueEditor } from "vue2-editor";
export default {
  components: {
    VueEditor
  },
  data() {
    return {
      label_position: "top",
      pic: "",
      picshow: '',
      file: null,
      form: {
        title_th: "",
        title_en: "",
        short_description_th: "",
        short_description_en: "",
        full_description_th: "",
        full_description_en: "",
        status: "",
        article_id:"",
        thumbnail_image:""
      },
      editor: ClassicEditor,
      editorData: "<p>Rich-text editor content.</p>",
      editorConfig: {}
    };
  },
  created() {
    this.$store.dispatch('articleStore/getArticle', this.$route.query)
  },
  computed: {
    ...mapState({
      current_article: store => store.articleStore.current_article
    })
  },
  mounted() {
    this.form.title_th = this.current_article.title_th;
    this.form.title_en = this.current_article.title_en;
    this.form.short_description_th = this.current_article.short_description_th;
    this.form.short_description_en = this.current_article.short_description_en;
    this.form.full_description_th = this.current_article.full_description_th;
    this.form.full_description_en = this.current_article.full_description_en;
    this.form.status = this.current_article.visible_status;
    this.form.article_id  = this.current_article.article_id,
    this.form.thumbnail_image = this.current_article.thumbnail_image;
    this.picshow = this.form.thumbnail_image != '' ? true : false
  },
  watch: {
    current_article: {
      handler : function(reload, empty) {
        let current_article = reload
        this.form.title_th = current_article.title_th;
        this.form.title_en = current_article.title_en;
        this.form.short_description_th = current_article.short_description_th;
        this.form.short_description_en = current_article.short_description_en;
        this.form.full_description_th = current_article.full_description_th;
        this.form.full_description_en = current_article.full_description_en;
        this.form.status = current_article.visible_status;
        this.form.article_id  = current_article.article_id,
        this.form.thumbnail_image = current_article.thumbnail_image;
        this.picshow = this.form.thumbnail_image != '' ? true : false
      }
    }
  },
  // mounted() {
  //   let detail = JSON.parse(this.$route.query.detail);
  //   console.log(detail)
  //   this.form.title_th = detail.title_th;
  //   this.form.title_en = detail.title_en;
  //   this.form.short_description_th = detail.short_description_th;
  //   this.form.short_description_en = detail.short_description_en;
  //   this.form.full_description_th = detail.full_description_th;
  //   this.form.full_description_en = detail.full_description_en;
  //   this.form.status = detail.visible_status.toString();
  //   this.form.article_id  = detail.article_id,
  //   this.form.thumbnail_image = this.config().API_URL + detail.thumbnail_image;
  //   this.picshow = this.form.thumbnail_image != '' ? true : false
  // },
  methods: {
    ...mapActions({
      editArticle: "articleStore/editArticle"
    }),
    onFileChange(e) {
      // this.file = e.target.files[0];
      // this.pic = URL.createObjectURL(this.file);
      this.$refs.file.clearFiles()
      this.file = e.raw;
      this.picshow = false
      this.pic = URL.createObjectURL(this.file);
    },
    submitForm() {
      let formData = new FormData();
      formData.append("typeFile", "article");
      formData.append("title_th", this.form.title_th);
      formData.append("title_en", this.form.title_en);
      formData.append("short_description_th", this.form.short_description_th);
      formData.append("short_description_en", this.form.short_description_en);
      formData.append("full_description_th", this.form.full_description_th);
      formData.append("full_description_en", this.form.full_description_en);
      formData.append("status", this.form.status);
      formData.append("article_id", this.form.article_id);
      formData.append("thumbnail_image", this.form.thumbnail_image);
      formData.append("file", this.file);
      formData.append("admin_id", this.$cookies.get("user_nbtc").admin_id)
      this.editArticle(formData);
    },
    back() {
      this.$router.push({ name: 'Manage_article' })
    }
  }
};
</script>
